export enum PricingInstruction {
    AUCTION = "AUCTION",
    BEST = "BEST",
    CP_LIMIT = "CP_LIMIT",
    CP_MARKET = "CP_MARKET",
    IMBALANCE = "IMBALANCE",
    LIMIT = "LIMIT",
    MARKET = "MARKET",
    MARKET_ON = "MARKET_ON",
    MARKET_ON_CLOSE = "MARKET_ON_CLOSE",
    VOLUME_MATCH = "VOLUME_MATCH",
    DARK_LIMIT = "DARK_LIMIT",
    MARKET_TO_LIMIT = "MARKET_TO_LIMIT",
    ANY_PRICE_BLOCK = "ANY_PRICE_BLOCK",
    BLANK = "BLANK",
    UNKNOWN = "UNKNOWN"
}

export function pricingInstructionName(instruction: PricingInstruction): string {
    switch (instruction) {
        case PricingInstruction.AUCTION:
            return "Auction";
        case PricingInstruction.BEST:
            return "Best";
        case PricingInstruction.LIMIT:
            return "Limit";
        case PricingInstruction.MARKET:
            return "Market";
        case PricingInstruction.MARKET_TO_LIMIT:
            return "Market-Limit";
        case PricingInstruction.MARKET_ON_CLOSE:
            return "Market on Close";
        case PricingInstruction.VOLUME_MATCH:
            return "Volume Match";
        case PricingInstruction.IMBALANCE:
            return "Imbalance";
        case PricingInstruction.MARKET_ON:
            return "Market O/N";
        case PricingInstruction.CP_LIMIT:
            return "CP Limit";
        case PricingInstruction.CP_MARKET:
            return "CP Market";
        case PricingInstruction.BLANK:
            return "";
        case PricingInstruction.ANY_PRICE_BLOCK:
            return "Any Price Block";
        case PricingInstruction.DARK_LIMIT:
            return "Dark Limit";
        case PricingInstruction.UNKNOWN:
            return "Unknown";
    }
}
